import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { fetchSimilarJobRequests } from "@/data/job-requests";
import { useFetcher } from "@/hooks/http";
import { JobsWidget } from "@/views/JobRequests/JobsWidget/JobsWidget";

interface SimilarJobsWidgetProps {
  jobRequestId: number;
  isPublic?: boolean;
}

export const SimilarJobsWidget: FC<SimilarJobsWidgetProps> = ({ jobRequestId, isPublic }) => {
  const { t } = useTranslation("session");

  const fetcher = useFetcher(fetchSimilarJobRequests, { jobRequestId }, [jobRequestId]);

  if (!fetcher.payload || (fetcher.payload && fetcher.payload.numberOfElements === 0)) {
    return null;
  }

  return (
    <JobsWidget header={t("JOB_REQUESTS.COMMON.SIMILAR_JOBS")} jobs={fetcher.payload.content} isPublic={isPublic} />
  );
};
